<template>
  <div class="CertificateInformation">
    <div class="CertificateInformation-wrapper" v-for="(CardsList, index) in CardsLists" :key="index">
      <!-- 证件类型 -->
      <div class="CertificateInformation-item">
        <div @click="cardDialog">{{ getCardType(Types) | mapTitle("CardType") }}</div>
        <div>{{ $t("mall.DocumentType") }}</div>
        <div>
          <img src="/static/img/left1.png" />
        </div>
      </div>
      <div class="border_bottom"></div>
      <div class="CertificateInformation-item">
        <div>
          <input v-model="CardsList.CardNo" type="text" :placeholder="$t('placeholders.CardNo')" />
        </div>
        <div>{{ $t("mall.CardNo") }}</div>
      </div>
      <div class="border_bottom"></div>
      <div class="CertificateInformation-item">
        <div @click="dateDialog">{{ selectedDatePickerText }}</div>
        <div>{{ $t("mall.ExpiryDate") }}</div>
        <div>
          <img src="/static/img/left1.png" />
        </div>
      </div>
      <div class="border_bottom"></div>
    </div>
    <picker @select="handleSelect(0, arguments)" ref="picker" :cancelTxt="cancelTxt" :confirmTxt="confirmTxt"></picker>
    <datePicker @input="handleSelectDate" ref="datePicker" :data="AllDates" :cancelTxt="cancelTxt" :confirmTxt="confirmTxt" :selected-index="selectedDatePickerIndex[0]"></datePicker>
  </div>
</template>
<style scoped>
  .CertificateInformation-item {
    position: relative;
  }

  .CertificateInformation-item > div {
    font-size: 0.399rem;
  }

  .CertificateInformation-item > div:first-child {
    margin-left: 2.527rem;
    height: 1.463rem;
    line-height: 1.463rem;
  }

  .CertificateInformation-item > div:nth-child(2) {
    position: absolute;
    top: 0;
    left: 0;
    width: 2.527rem;
    height: 1.463rem;
    line-height: 1.463rem;
  }

  .CertificateInformation-item > div:nth-child(3) {
    position: absolute;
    top: 0;
    right: 0;
    height: 1.463rem;
    line-height: 1.463rem;
  }

  .CertificateInformation-item img {
    width: 0.372rem;
    vertical-align: middle;
  }

  .CertificateInformation-item input {
    border: none;
    height: 100%;
    width: 100%;
  }

  .CertificateInformation input:focus {
    outline: none;
  }

  .CertificateInformation-item input::-webkit-input-placeholder {
    color: #b6b6b6;
  }

  .CertificateInformation-item input:-moz-placeholder {
    color: #b6b6b6;
  }

  .CertificateInformation-item input:-ms-input-placeholder {
    color: #b6b6b6;
  }
</style>
<script>
  import { categoryMap, Categorys } from "@/model/Base";
  import datePicker from "../../modules/date-picker.vue";
  import picker from "../../modules/picker.vue";
  import enumUtils from "@/utils/enumUtils";
  export default {
    data() {
      return {
        selectedIndex: [],
        cancelTxt: "share.cancelTxt",
        confirmTxt: "share.confirmTxt",
        selectedText: [],
        AllDates: [
          {
            minDate: 1899,
            maxDate: 2200,
          },
          {
            minDate: 0,
            maxDate: 12,
          },
          {
            minDate: 0,
            maxDate: 31,
          },
        ],
        selectedDatePickerText: "",
        selectedDatePickerIndex: [[0, 0, 0]],
      };
    },
    filters: {
      mapTitle(code) {
        return categoryMap[code].CategoryName;
      },
    },
    props: ["CardsLists", "Types", "value"],
    computed: {
      CardTypes() {
        let __self = this;
        let list = enumUtils.makeCategorys(Categorys.CardType);
        return list;
      },
    },
    watch: {
      CardsLists(newVal) {
        let __self = this;
        for (let i = 0; i < newVal.length; i++) {
          __self.selectedDatePickerText = newVal[i].ExpireDate;
          __self.$refs.datePicker.setSelectedIndex(__self.selectedDatePickerText);
        }
      },
    },
    activated() {
      let __self = this;

      for (let i = 0; i < __self.CardsLists.length; i++) {
        __self.selectedDatePickerText = __self.CardsLists[i].ExpireDate;
        __self.$refs.datePicker.setSelectedIndex(__self.selectedDatePickerText);
      }

      for (let i = 0; i < __self.CardTypes.length; i++) {
        __self.CardTypes[i].value = __self.CardTypes[i].CategoryID;
        __self.CardTypes[i].label = __self.CardTypes[i].CategoryTitle;
        if (__self.CardTypes[i].CategoryID == __self.Types.Card) {
          __self.$refs.picker.setSelectedIndex([i]);
          __self.selectedText.push(__self.CardTypes[i + 1]);
        }
      }
      __self.$refs.picker.setData([__self.CardTypes]);
    },
    methods: {
      getCardType(Types) {
        return Types.Card;
      },
      cardDialog() {
        let __self = this;
        for (let i = 0; i < __self.CardTypes.length; i++) {
          __self.CardTypes[i].value = __self.CardTypes[i].CategoryID;
          __self.CardTypes[i].label = __self.CardTypes[i].CategoryTitle;
          if (__self.CardTypes[i].CategoryID == __self.Types.Card) {
            __self.$refs.picker.setSelectedIndex([i]);
            __self.selectedText.push(__self.CardTypes[i + 1]);
          }
        }
        __self.$refs.picker.show();
      },
      dateDialog() {
        let __self = this;
        __self.$refs.datePicker.setSelectedIndex(__self.selectedDatePickerText);
        __self.$refs.datePicker.show();
      },
      handleSelectDate(value) {
        let __self = this;
        __self.selectedDatePickerText = value;
        let Card = _.find(__self.CardsLists, function(o) {
          return o.CardType == __self.Types.Card;
        });
        Card.ExpireDate = value;
      },
      handleSelect(index, args) {
        let __self = this;
        __self.selectedText.splice(index, 1, args[2][0]);
        __self.Types.Card = __self.selectedText[0].value;
      },
    },
    components: {
      picker,
      datePicker,
    },
  };
</script>
